var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.863,
    height: 66.863,
    viewBox: "0 0 66.863 66.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f9f9f9;opacity:0.4;}.b{fill:#26c6da;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.326,66.863H12.537A12.536,12.536,0,0,1,0,54.326V12.537A12.536,12.536,0,0,1,12.537,0H54.326A12.536,12.536,0,0,1,66.863,12.537V54.326A12.536,12.536,0,0,1,54.326,66.863Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.859,8A20.859,20.859,0,1,0,49.717,28.859,20.883,20.883,0,0,0,28.859,8Zm9.126,22.6H30.6v7.387a1.739,1.739,0,1,1-3.478,0V30.6H19.733a1.739,1.739,0,0,1,0-3.478H27.12V19.733a1.739,1.739,0,0,1,3.478,0V27.12h7.387a1.739,1.739,0,1,1,0,3.478Z",
    transform: "translate(4.573 4.573)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEvaluation);
export default __webpack_public_path__ + "static/media/add-evaluation.67eaf7b8a38e1f2f1fc4fdf13e529476.svg";
export { ForwardRef as ReactComponent };